<script setup lang="ts">
import { Component } from '@/types/api/api-v3/product'

type Props = {
  component: Component
}
const props = defineProps<Props>()

const isErrorImage = ref(false)

const imageUrl = computed(() => {
  if (!props.component?.image || isErrorImage.value) {
    return './no-image-category.webp'
  }

  return props.component.image
})
</script>

<template>
  <div class="product-detail-component">
    <nuxt-img
      class="product-detail-component__image"
      :src="imageUrl"
      :alt="component.name"
      @error="isErrorImage = true"
    />

    <div class="product-detail-component__text">
      <h5 class="product-detail-component__title">{{ component.name }}</h5>

      <p class="product-detail-component__description">
        {{ component.description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-detail-component {
  display: flex;
  gap: 16px;
  padding-bottom: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--ui-grey);
  }

  &__image {
    width: 60px;
    height: 40px;
    border-radius: 6px;
  }

  &__text {
    font-size: 14px;
    line-height: 18px;
    word-wrap: break-word;
  }

  &__title {
    font-size: 14px;
    font-weight: 800;
    color: var(--ui-secondary);
  }

  &__description {
    margin-top: 8px;
    font-weight: 600;
    color: var(--ui-dark-grey);
  }
}
</style>
